import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { SUITEVIEWPATH } from '~/core/core.routing';
import { MeetingPointer } from '~/repositories/meetingpointers/models';

@Component({
  selector: 'app-meetingpointers-dialog',
  templateUrl: './meetingpointers-dialog.component.html',
  styleUrls: ['./meetingpointers-dialog.component.scss'],
  standalone: false
})
export class MeetingpointersDialogComponent {
  @Input() visible: boolean;

  @Input() meetingPointers: MeetingPointer[];

  @Output() visibleChange = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private translateService: TranslateService
  ) {}

  onClose() {
    this.visibleChange.emit(false);
  }

  navigateToMeeting(id: number) {
    this.onClose();
    this.router.navigate([this.translateService.instant('ROUTES.meeting'), id]);
  }

  navigateToSuiteView(url: string) {
    this.onClose();
    this.router.navigateByUrl(`${SUITEVIEWPATH}/${url}`);
  }
}
